import { motion } from "framer-motion";
import { Award, Heart, MapPin, Quote } from "lucide-react";

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 md:py-32 bg-brand-cream"
    >
      <div className="container-app">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl"
        >
          <p className="overline mb-4">About Javier &amp; the Team</p>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-brand-navy tracking-tight">
            Built by a Floridian who has been on the other side of the table.
          </h2>
        </motion.div>

        <div className="mt-12 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="lg:col-span-7 space-y-5 text-base md:text-lg text-brand-muted leading-relaxed"
          >
            <p>
              J K Awesome Deeds LLC was founded by Javier Cruz — a Florida
              real estate investor who watched a member of his own family
              lose their home to a foreclosure that, with the right help,
              never had to happen.
            </p>
            <p>
              Today, our team specializes in three things and three things
              only: <span className="text-brand-navy font-medium">stopping foreclosure</span>,
              <span className="text-brand-navy font-medium"> expediting short sales</span>, and
              <span className="text-brand-navy font-medium"> buying houses for cash</span>. We
              acquire, reposition, and steward properties as part of a
              long-term equity portfolio — which means we are not chasing the
              next deal. We are here for the next decade.
            </p>
            <p className="text-sm border-l-2 border-brand-gold pl-4 py-1">
              <span className="font-medium text-brand-navy">A note on our role:</span>{" "}
              J K Awesome Deeds LLC is a Florida-registered for-profit
              investment company — not a licensed real estate brokerage. We
              buy properties as a principal and partner with licensed
              Realtors, brokers, and real-estate capital groups when listing
              services are needed.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="lg:col-span-5"
          >
            {/* Founder quote card */}
            <div className="bg-brand-navy text-brand-cream rounded-md p-7 md:p-8">
              <Quote className="h-8 w-8 text-brand-gold mb-4" />
              <p className="font-accent text-lg md:text-xl leading-relaxed text-brand-cream/95">
                "We treat every homeowner the way I wish someone had treated my
                family — with patience, real options, and zero pressure."
              </p>
              <div className="mt-6 pt-6 border-t border-brand-cream/20">
                <p className="font-heading font-semibold text-brand-cream">
                  Javier Cruz
                </p>
                <p className="text-sm text-brand-cream/70">
                  Founder · J K Awesome Deeds LLC
                </p>
              </div>
            </div>

            <div className="mt-5 grid grid-cols-3 gap-3">
              {[
                { icon: Award, title: "FL Registered", body: "For-profit LLC" },
                { icon: Heart, title: "Empathy", body: "Homeowner-first" },
                { icon: MapPin, title: "Local", body: "Central FL" },
              ].map((item) => (
                <div
                  key={item.title}
                  className="p-4 rounded-md bg-white border border-brand-line"
                >
                  <item.icon className="h-5 w-5 text-brand-gold mb-2" />
                  <p className="font-heading font-semibold text-sm text-brand-navy leading-tight">
                    {item.title}
                  </p>
                  <p className="text-xs text-brand-muted mt-0.5">{item.body}</p>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
